import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { MessagesSearch, Error } from '@swyftx/aviary/icons/outlined';

type Props = {
  filtersActive: boolean;
  isError?: boolean;
  onClearFilters: () => void;
};

const MarginHistoryTableEmpty: React.FC<Props> = ({ filtersActive, isError, onClearFilters }) => {
  const { t } = useTranslation('margin');

  const title = useMemo(() => {
    if (isError) return t('tables.history.empty.title.failed');

    return t('tables.history.empty.title.history');
  }, [isError, t]);

  const content = useMemo(() => {
    if (isError) return t('tables.history.empty.content.failed');

    if (filtersActive) return t('tables.history.empty.content.filter');

    return t('tables.history.empty.content.history');
  }, [filtersActive, isError, t]);

  return (
    <FlexLayout className='h-full w-full' alignItems='center' justifyContent='center' direction='column' spacing={8}>
      {isError ? (
        <Error className='h-48 w-48 text-color-text-accent' />
      ) : (
        <MessagesSearch className='h-48 w-48 text-color-text-accent' />
      )}
      <Heading size='h5'>{title}</Heading>
      <Body color='secondary' size='small' className='text-center'>
        {content}
      </Body>
      {filtersActive && !isError && (
        <Button onClick={onClearFilters}>{t('tables.history.empty.actions.clearFilters')}</Button>
      )}
    </FlexLayout>
  );
};

export { MarginHistoryTableEmpty };
